import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';

// Pages
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import SuperAdminPage from './pages/SuperAdminPage';
import DashboardPage from './pages/DashboardPage';
import CrearGuiaPage from './pages/CrearGuiaPage';
import MisGuiasPage from './pages/MisGuiasPage';
import AprobarGuiasPage from './pages/AprobarGuiasPage';
import PuntoSalidaPage from './pages/PuntoSalidaPage';
import EscanerQRPage from './pages/EscanerQRPage';
import DocumentosPage from './pages/DocumentosPage';
import DocumentoDetallePage from './pages/DocumentoDetallePage';
import ReportesGuiasPage from './pages/ReportesGuiasPage';

// Diesel Module
import { DieselProvider } from './context/DieselContext';
import DieselDashboardPage from './pages/diesel/DieselDashboardPage';
import DieselConfiguracionPage from './pages/diesel/DieselConfiguracionPage';
import DieselVehiculosPage from './pages/diesel/DieselVehiculosPage';
import DieselConductoresPage from './pages/diesel/DieselConductoresPage';
import DieselCargasPage from './pages/diesel/DieselCargasPage';
import DieselNuevaCargaPage from './pages/diesel/DieselNuevaCargaPage';
import DieselAlertasPage from './pages/diesel/DieselAlertasPage';
import DieselVehiculoDetallePage from './pages/diesel/DieselVehiculoDetallePage';
import DieselReportesPage from './pages/diesel/DieselReportesPage';

// Alarmas Module
import AlarmasPanelPage from './pages/alarmas/AlarmasPanelPage';
import AlarmasAdminPage from './pages/alarmas/AlarmasAdminPage';
import AlarmasHistorialPage from './pages/alarmas/AlarmasHistorialPage';
import AlarmasRegistroPublicoPage from './pages/alarmas/AlarmasRegistroPublicoPage';
import AlarmasManualPage from './pages/alarmas/AlarmasManualPage';
import CodelcoDashboardPage from './pages/codelco/CodelcoDashboardPage';
import CodelcoVehiculosPage from './pages/codelco/CodelcoVehiculosPage';
import CodelcoConfigPage from './pages/codelco/CodelcoConfigPage';
import CodelcoBitacoraPage from './pages/codelco/CodelcoBitacoraPage';
import CodelcoNotificacionesPage from './pages/codelco/CodelcoNotificacionesPage';
import CodelcoMapeoPage from './pages/codelco/CodelcoMapeoPage';
import CodelcoPerfilesPage from './pages/codelco/CodelcoPerfilesPage';

// Gestión 4sat Module
import G4sDashboardPage from './pages/gestion4sat/G4sDashboardPage';
import G4sEmpresasPage from './pages/gestion4sat/G4sEmpresasPage';
import G4sEmpresaDetallePage from './pages/gestion4sat/G4sEmpresaDetallePage';
import G4sDispositivosPage from './pages/gestion4sat/G4sDispositivosPage';
import G4sServiciosPage from './pages/gestion4sat/G4sServiciosPage';
import G4sServicioFormPage from './pages/gestion4sat/G4sServicioFormPage';
import G4sServicioDetallePage from './pages/gestion4sat/G4sServicioDetallePage';
import G4sFacturacionPage from './pages/gestion4sat/G4sFacturacionPage';
import G4sConciliacionPage from './pages/gestion4sat/G4sConciliacionPage';
import G4sConectividadPage from './pages/gestion4sat/G4sConectividadPage';
import G4sOrdenesTrabajoPage from './pages/gestion4sat/G4sOrdenesTrabajoPage';
import G4sMapaAdminPage from './pages/gestion4sat/G4sMapaAdminPage';
import G4sTecnicoPage from './pages/gestion4sat/G4sTecnicoPage';
import G4sAlertasPage from './pages/gestion4sat/G4sAlertasPage';
import G4sImportarPage from './pages/gestion4sat/G4sImportarPage';
import G4sConfigPage from './pages/gestion4sat/G4sConfigPage';

import CargaMasivaPage from './pages/CargaMasivaPage';
import ConfiguracionPage from './pages/ConfiguracionPage';
import ConfiguracionGuiasPage from './pages/ConfiguracionGuiasPage';
import HistorialPage from './pages/HistorialPage';
import UsuariosPage from './pages/UsuariosPage';
import GestionUsuariosPage from './pages/GestionUsuariosPage';

// Bomberos Module Pages
import BomberosDashboardPage from './pages/bomberos/BomberosDashboardPage';
import BomberosCompaniasPage from './pages/bomberos/BomberosCompaniasPage';
import BomberosPersonalPage from './pages/bomberos/BomberosPersonalPage';
import BomberosMaterialMayorPage from './pages/bomberos/BomberosMaterialMayorPage';
import MaterialMayorDetallePage from './pages/bomberos/MaterialMayorDetallePage';
import BomberosCapacitacionesPage from './pages/bomberos/BomberosCapacitacionesPage';
import BomberosEPPPage from './pages/bomberos/BomberosEPPPage';
import BomberoFormPage from './pages/bomberos/BomberoFormPage';
import VehiculoFormPage from './pages/bomberos/VehiculoFormPage';
import EPPFormPage from './pages/bomberos/EPPFormPage';
import BomberoDetallePage from './pages/bomberos/BomberoDetallePage';
import BomberosReportesPage from './pages/bomberos/BomberosReportesPage';
import BomberosAlertasPage from './pages/bomberos/BomberosAlertasPage';
import BomberosConfiguracionPage from './pages/bomberos/BomberosConfiguracionPage';
import CapacitacionFormPage from './pages/bomberos/CapacitacionFormPage';
import CapacitacionDetallePage from './pages/bomberos/CapacitacionDetallePage';
import ActaFormPage from './pages/bomberos/ActaFormPage';
import BomberosActasPage from './pages/bomberos/BomberosActasPage';
import ActaDetallePage from './pages/bomberos/ActaDetallePage';
import BomberosImportacionPage from './pages/bomberos/BomberosImportacionPage';
import BomberosEstadisticasPage from './pages/bomberos/BomberosEstadisticasPage';
import BomberosValidacionBajasPage from './pages/bomberos/BomberosValidacionBajasPage';
import ActividadesExtraPage from './pages/bomberos/ActividadesExtraPage';
import ActividadFormPage from './pages/bomberos/ActividadFormPage';
import ActividadDetallePage from './pages/bomberos/ActividadDetallePage';
import MallaCurricularPage from './pages/bomberos/MallaCurricularPage';
import ImportarCapacitacionesPage from './pages/bomberos/ImportarCapacitacionesPage';
import ConfiguradorMallaPage from './pages/bomberos/ConfiguradorMallaPage';

// Ordenes de Servicio Module Pages
import OrdenesDashboardPage from './pages/ordenes/OrdenesDashboardPage';
import OrdenesClientesPage from './pages/ordenes/OrdenesClientesPage';
import ClienteDetallePage from './pages/ordenes/ClienteDetallePage';
import OrdenesListPage from './pages/ordenes/OrdenesListPage';
import OrdenFormPage from './pages/ordenes/OrdenFormPage';
import OrdenDetallePage from './pages/ordenes/OrdenDetallePage';
import OrdenesInventarioPage from './pages/ordenes/OrdenesInventarioPage';
import OrdenesVehiculosPage from './pages/ordenes/OrdenesVehiculosPage';
import VehiculoDetallePage from './pages/ordenes/VehiculoDetallePage';
import OrdenesDispositivosPage from './pages/ordenes/OrdenesDispositivosPage';
import DispositivosInstaladosPage from './pages/ordenes/DispositivosInstaladosPage';
import OrdenesConfigPage from './pages/ordenes/OrdenesConfigPage';
import OrdenesCalendarioPage from './pages/ordenes/OrdenesCalendarioPage';
import OrdenesReportesPage from './pages/ordenes/OrdenesReportesPage';
import ReportesCustomPage from './pages/ordenes/ReportesCustomPage';
import CertificadosPage from './pages/ordenes/CertificadosPage';
import OrdenesImportacionPage from './pages/ordenes/OrdenesImportacionPage';
import OrdenesCamposConfigPage from './pages/ordenes/OrdenesCamposConfigPage';
import OrdenesNotificacionesPage from './pages/ordenes/OrdenesNotificacionesPage';
import TecnicoMobileView from './pages/ordenes/TecnicoMobileView';
import FourSatIntegrationPage from './pages/ordenes/FourSatIntegrationPage';

// Settings Pages
import ThemeConfigPage from './pages/settings/ThemeConfigPage';
import NotificationsConfigPage from './pages/settings/NotificationsConfigPage';

// Admin Pages
import RegistroActividadesPage from './pages/admin/RegistroActividadesPage';

// Portero GPS Module
import PorteroLoginPage from './pages/portero/PorteroLoginPage';
import PorteroPanelPage from './pages/portero/PorteroPanelPage';
import PorteroConfigPage from './pages/portero/PorteroConfigPage';
import PorteroLogPage from './pages/portero/PorteroLogPage';

// Public pages (no auth required)
import CompletarOrdenClientePage from './pages/CompletarOrdenClientePage';

import './App.css';

// Protected Route Component
const ProtectedRoute = ({ children, allowedRoles = [] }) => {
    const { isAuthenticated, user, loading } = useAuth();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background">
                <div className="animate-pulse">
                    <div className="h-8 w-8 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    // SuperAdmin can access everything
    if (user?.rol === 'superadmin') {
        return children;
    }

    if (allowedRoles.length > 0 && !allowedRoles.includes(user?.rol)) {
        return <Navigate to="/home" replace />;
    }

    return children;
};

// Protected Route for Bomberos Module - allows users with bomberos role assigned
const BomberosProtectedRoute = ({ children }) => {
    const { isAuthenticated, user, loading } = useAuth();
    const [checkingBomberosAccess, setCheckingBomberosAccess] = React.useState(true);
    const [hasAccess, setHasAccess] = React.useState(false);

    React.useEffect(() => {
        const checkAccess = async () => {
            // Admin, gerente, superadmin always have access
            if (user?.rol === 'superadmin' || user?.rol === 'admin' || user?.rol === 'gerente') {
                setHasAccess(true);
                setCheckingBomberosAccess(false);
                return;
            }

            // For regular users, check if they have a bomberos role assigned
            try {
                const { bomberosRolesAPI } = await import('./lib/api');
                const res = await bomberosRolesAPI.getMisPermisos();
                // If they have any permissions or a role, they have access
                const permisos = res.data.permisos || [];
                const rol = res.data.rol;
                setHasAccess(permisos.length > 0 || !!rol);
            } catch (err) {
                console.error('Error checking bomberos access:', err);
                setHasAccess(false);
            } finally {
                setCheckingBomberosAccess(false);
            }
        };

        if (isAuthenticated && !loading) {
            checkAccess();
        } else if (!loading) {
            setCheckingBomberosAccess(false);
        }
    }, [isAuthenticated, user, loading]);

    if (loading || checkingBomberosAccess) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background">
                <div className="animate-pulse">
                    <div className="h-8 w-8 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (!hasAccess) {
        return <Navigate to="/home" replace />;
    }

    return children;
};

// Public Route (redirect if authenticated)
const PublicRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background">
                <div className="animate-pulse">
                    <div className="h-8 w-8 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
                </div>
            </div>
        );
    }

    if (isAuthenticated) {
        return <Navigate to="/home" replace />;
    }

    return children;
};

// QR Redirect Route (handles /qr/:id URLs)
const QRRedirectRoute = () => {
    const { isAuthenticated, user, loading } = useAuth();
    const docId = window.location.pathname.split('/qr/')[1];

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background">
                <div className="animate-pulse">
                    <div className="h-8 w-8 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        // Store the QR URL to redirect after login
        sessionStorage.setItem('qr_redirect', docId);
        return <Navigate to="/login" replace />;
    }

    // If security, go to escaner with auto-load
    if (user?.rol === 'seguridad' || user?.rol === 'superadmin') {
        return <Navigate to={`/guias/documento/${docId}`} replace />;
    }

    // Others go to document detail
    return <Navigate to={`/guias/documento/${docId}`} replace />;
};

// Para rol seguridad/PI, su "área de inicio" es el punto de salida (escaneo + listado).
// Para los demás, va al DashboardPage estándar.
const GuiasDashboardRedirect = () => {
    const { user } = useAuth();
    if (user?.rol === 'seguridad') {
        return <Navigate to="/guias/todos" replace />;
    }
    return <DashboardPage />;
};

function AppRoutes() {
    return (
        <Routes>
            {/* Public Routes */}
            <Route
                path="/login"
                element={
                    <PublicRoute>
                        <LoginPage />
                    </PublicRoute>
                }
            />

            {/* QR Code redirect */}
            <Route path="/qr/:id" element={<QRRedirectRoute />} />

            {/* Public Route - Cliente completa orden (sin autenticación) */}
            <Route path="/completar-orden/:token" element={<CompletarOrdenClientePage />} />

            {/* Public Route - Registro Alarmas por link del admin */}
            <Route path="/alarmas/registro/:token" element={<AlarmasRegistroPublicoPage />} />

            {/* Home - Module Selection */}
            <Route
                path="/home"
                element={
                    <ProtectedRoute>
                        <HomePage />
                    </ProtectedRoute>
                }
            />

            {/* SuperAdmin Routes */}
            <Route
                path="/superadmin"
                element={
                    <ProtectedRoute allowedRoles={['superadmin']}>
                        <SuperAdminPage />
                    </ProtectedRoute>
                }
            />

            {/* Gestión de Usuarios */}
            <Route
                path="/gestion-usuarios"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                        <GestionUsuariosPage />
                    </ProtectedRoute>
                }
            />

            {/* Guías de Despacho Module Routes */}
            <Route
                path="/guias/dashboard"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'solicitante', 'gerente', 'seguridad', 'superadmin']}>
                        <GuiasDashboardRedirect />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/guias/documento/:id"
                element={
                    <ProtectedRoute>
                        <DocumentoDetallePage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/guias/crear"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'solicitante']}>
                        <CrearGuiaPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/guias/mis-guias"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'solicitante']}>
                        <MisGuiasPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/guias/aprobar"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'gerente']}>
                        <AprobarGuiasPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/guias/punto-salida"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'seguridad']}>
                        <PuntoSalidaPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/guias/escaner"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'seguridad']}>
                        <EscanerQRPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/guias/todos"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'gerente', 'seguridad', 'superadmin']}>
                        <DocumentosPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/guias/reportes"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'gerente', 'seguridad', 'superadmin']}>
                        <ReportesGuiasPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/guias/usuarios"
                element={
                    <ProtectedRoute allowedRoles={['admin']}>
                        <UsuariosPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/guias/carga-masiva"
                element={
                    <ProtectedRoute allowedRoles={['admin']}>
                        <CargaMasivaPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/guias/configuracion"
                element={
                    <ProtectedRoute allowedRoles={['admin']}>
                        <ConfiguracionPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/guias/historial"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'gerente']}>
                        <HistorialPage />
                    </ProtectedRoute>
                }
            />

            {/* Legacy routes - redirect to new structure */}
            <Route path="/dashboard" element={<Navigate to="/guias/dashboard" replace />} />
            <Route path="/crear-guia" element={<Navigate to="/guias/crear" replace />} />
            <Route path="/mis-guias" element={<Navigate to="/guias/mis-guias" replace />} />
            <Route path="/aprobar" element={<Navigate to="/guias/aprobar" replace />} />
            <Route path="/punto-salida" element={<Navigate to="/guias/punto-salida" replace />} />
            <Route path="/documentos" element={<Navigate to="/guias/todos" replace />} />
            <Route path="/documento/:id" element={<Navigate to="/guias/documento/:id" replace />} />
            <Route path="/usuarios" element={<Navigate to="/guias/usuarios" replace />} />
            <Route path="/carga-masiva" element={<Navigate to="/guias/carga-masiva" replace />} />
            <Route path="/configuracion" element={<Navigate to="/guias/configuracion" replace />} />
            <Route path="/historial" element={<Navigate to="/guias/historial" replace />} />

            {/* ==================== BOMBEROS MODULE ROUTES ==================== */}
            <Route
                path="/bomberos/dashboard"
                element={
                    <BomberosProtectedRoute>
                        <BomberosDashboardPage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/companias"
                element={
                    <BomberosProtectedRoute>
                        <BomberosCompaniasPage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/personal"
                element={
                    <BomberosProtectedRoute>
                        <BomberosPersonalPage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/material-mayor"
                element={
                    <BomberosProtectedRoute>
                        <BomberosMaterialMayorPage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/capacitaciones"
                element={
                    <BomberosProtectedRoute>
                        <BomberosCapacitacionesPage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/capacitaciones/nueva"
                element={
                    <BomberosProtectedRoute>
                        <CapacitacionFormPage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/capacitaciones/:id"
                element={
                    <BomberosProtectedRoute>
                        <CapacitacionDetallePage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/capacitaciones/:id/editar"
                element={
                    <BomberosProtectedRoute>
                        <CapacitacionFormPage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/actas/nueva"
                element={
                    <BomberosProtectedRoute>
                        <ActaFormPage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/actas"
                element={
                    <BomberosProtectedRoute>
                        <BomberosActasPage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/actas/:id"
                element={
                    <BomberosProtectedRoute>
                        <ActaDetallePage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/importacion"
                element={
                    <BomberosProtectedRoute>
                        <BomberosImportacionPage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/malla-curricular"
                element={
                    <BomberosProtectedRoute>
                        <MallaCurricularPage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/malla-curricular/configurador"
                element={
                    <BomberosProtectedRoute>
                        <ConfiguradorMallaPage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/capacitaciones/importar"
                element={
                    <BomberosProtectedRoute>
                        <ImportarCapacitacionesPage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/estadisticas"
                element={
                    <BomberosProtectedRoute>
                        <BomberosEstadisticasPage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/epp"
                element={
                    <BomberosProtectedRoute>
                        <BomberosEPPPage />
                    </BomberosProtectedRoute>
                }
            />

            {/* Bomberos Forms */}
            <Route
                path="/bomberos/personal/nuevo"
                element={
                    <BomberosProtectedRoute>
                        <BomberoFormPage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/personal/:id/editar"
                element={
                    <BomberosProtectedRoute>
                        <BomberoFormPage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/personal/:id"
                element={
                    <BomberosProtectedRoute>
                        <BomberoDetallePage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/material-mayor/nuevo"
                element={
                    <BomberosProtectedRoute>
                        <VehiculoFormPage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/material-mayor/:id/editar"
                element={
                    <BomberosProtectedRoute>
                        <VehiculoFormPage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/material-mayor/:id"
                element={
                    <BomberosProtectedRoute>
                        <MaterialMayorDetallePage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/epp/nuevo"
                element={
                    <BomberosProtectedRoute>
                        <EPPFormPage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/epp/:id/editar"
                element={
                    <BomberosProtectedRoute>
                        <EPPFormPage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/reportes"
                element={
                    <BomberosProtectedRoute>
                        <BomberosReportesPage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/alertas"
                element={
                    <BomberosProtectedRoute>
                        <BomberosAlertasPage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/configuracion"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                        <BomberosConfiguracionPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/bomberos/validacion-bajas"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                        <BomberosValidacionBajasPage />
                    </ProtectedRoute>
                }
            />

            {/* Actividades Extra Programáticas */}
            <Route
                path="/bomberos/actividades"
                element={
                    <BomberosProtectedRoute>
                        <ActividadesExtraPage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/actividades/nueva"
                element={
                    <BomberosProtectedRoute>
                        <ActividadFormPage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/actividades/:id"
                element={
                    <BomberosProtectedRoute>
                        <ActividadDetallePage />
                    </BomberosProtectedRoute>
                }
            />
            <Route
                path="/bomberos/actividades/:id/editar"
                element={
                    <BomberosProtectedRoute>
                        <ActividadFormPage />
                    </BomberosProtectedRoute>
                }
            />

            {/* Órdenes de Servicio Module */}
            <Route
                path="/ordenes/dashboard"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                        <OrdenesDashboardPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/ordenes/clientes"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                        <OrdenesClientesPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/ordenes/clientes/:clienteId"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                        <ClienteDetallePage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/ordenes/ordenes"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                        <OrdenesListPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/ordenes/nueva"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                        <OrdenFormPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/ordenes/ordenes/:ordenId"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                        <OrdenDetallePage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/ordenes/inventario"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                        <OrdenesInventarioPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/ordenes/vehiculos"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                        <OrdenesVehiculosPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/ordenes/vehiculos/:vehiculoId"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                        <VehiculoDetallePage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/ordenes/dispositivos"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                        <OrdenesDispositivosPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/ordenes/dispositivos-instalados"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                        <DispositivosInstaladosPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/ordenes/configuracion"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                        <OrdenesConfigPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/ordenes/calendario"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                        <OrdenesCalendarioPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/ordenes/reportes"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                        <OrdenesReportesPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/ordenes/reportes/constructor"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                        <ReportesCustomPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/ordenes/certificados"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin', 'tecnico']}>
                        <CertificadosPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/ordenes/importacion"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                        <OrdenesImportacionPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/ordenes/configuracion/campos"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                        <OrdenesCamposConfigPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/ordenes/configuracion/notificaciones"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                        <OrdenesNotificacionesPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/ordenes/tecnico"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin', 'tecnico', 'supervisor']}>
                        <TecnicoMobileView />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/ordenes/integraciones/4sat"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                        <FourSatIntegrationPage />
                    </ProtectedRoute>
                }
            />

            {/* Bomberos - Registro de Actividades */}
            <Route
                path="/bomberos/registro-actividades"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                        <RegistroActividadesPage />
                    </ProtectedRoute>
                }
            />

            {/* Settings Routes */}
            <Route
                path="/configuracion/tema"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                        <ThemeConfigPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/configuracion/notificaciones"
                element={
                    <ProtectedRoute allowedRoles={['admin', 'superadmin', 'tecnico', 'supervisor']}>
                        <NotificationsConfigPage />
                    </ProtectedRoute>
                }
            />

            {/* ============ MÓDULO PORTERO GPS ============ */}
            <Route path="/portero" element={<PorteroLoginPage />} />
            <Route path="/portero/panel" element={<PorteroPanelPage />} />
            <Route path="/portero/config" element={<PorteroConfigPage />} />
            <Route path="/portero/log" element={<PorteroLogPage />} />

            {/* Default redirect */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/home" replace />} />

            {/* ============ MÓDULO DIESEL ============ */}
            <Route
                path="/diesel/*"
                element={
                    <ProtectedRoute>
                        <DieselProvider>
                            <Routes>
                                <Route path="dashboard" element={<DieselDashboardPage />} />
                                <Route path="configuracion" element={<DieselConfiguracionPage />} />
                                <Route path="vehiculos" element={<DieselVehiculosPage />} />
                                <Route path="conductores" element={<DieselConductoresPage />} />
                                <Route path="cargas" element={<DieselCargasPage />} />
                                <Route path="cargas/nueva" element={<DieselNuevaCargaPage />} />
                                <Route path="alertas" element={<DieselAlertasPage />} />
                                <Route path="reportes" element={<DieselReportesPage />} />
                                <Route path="vehiculos/:vehiculoId" element={<DieselVehiculoDetallePage />} />
                                <Route path="*" element={<Navigate to="/diesel/dashboard" replace />} />
                            </Routes>
                        </DieselProvider>
                    </ProtectedRoute>
                }
            />

            {/* ============ MÓDULO ALARMAS_LS ============ */}
            <Route
                path="/alarmas/*"
                element={
                    <ProtectedRoute>
                        <Routes>
                            <Route path="panel" element={<AlarmasPanelPage />} />
                            <Route path="admin" element={<AlarmasAdminPage />} />
                            <Route path="historial" element={<AlarmasHistorialPage />} />
                            <Route path="manual" element={<AlarmasManualPage />} />
                            <Route path="*" element={<Navigate to="/alarmas/panel" replace />} />
                        </Routes>
                    </ProtectedRoute>
                }
            />

            {/* Integrador Codelco-Samtech */}
            <Route
                path="/codelco/*"
                element={
                    <ProtectedRoute>
                        <Routes>
                            <Route path="dashboard" element={<CodelcoDashboardPage />} />
                            <Route path="vehiculos" element={<CodelcoVehiculosPage />} />
                            <Route path="perfiles" element={<CodelcoPerfilesPage />} />
                            <Route path="mapeo" element={<CodelcoMapeoPage />} />
                            <Route path="bitacora" element={<CodelcoBitacoraPage />} />
                            <Route path="notificaciones" element={<CodelcoNotificacionesPage />} />
                            <Route path="config" element={<CodelcoConfigPage />} />
                            <Route path="*" element={<Navigate to="/codelco/dashboard" replace />} />
                        </Routes>
                    </ProtectedRoute>
                }
            />

            {/* ============ MÓDULO GESTIÓN 4SAT ============ */}
            <Route
                path="/gestion4sat/*"
                element={
                    <ProtectedRoute>
                        <Routes>
                            <Route path="dashboard" element={<G4sDashboardPage />} />
                            <Route path="empresas" element={<G4sEmpresasPage />} />
                            <Route path="empresas/:empresaId" element={<G4sEmpresaDetallePage />} />
                            <Route path="dispositivos" element={<G4sDispositivosPage />} />
                            <Route path="servicios" element={<G4sServiciosPage />} />
                            <Route path="servicios/nuevo" element={<G4sServicioFormPage />} />
                            <Route path="servicios/:servicioId" element={<G4sServicioDetallePage />} />
                            <Route path="facturacion" element={<G4sFacturacionPage />} />
                            <Route path="conciliacion" element={<G4sConciliacionPage />} />
                            <Route path="conectividad" element={<G4sConectividadPage />} />
                            <Route path="ordenes" element={<G4sOrdenesTrabajoPage />} />
                            <Route path="mapa" element={<G4sMapaAdminPage />} />
                            <Route path="tecnico" element={<G4sTecnicoPage />} />
                            <Route path="tecnico/orden/:ordenId" element={<G4sTecnicoPage />} />
                            <Route path="alertas" element={<G4sAlertasPage />} />
                            <Route path="importar" element={<G4sImportarPage />} />
                            <Route path="config" element={<G4sConfigPage />} />
                            <Route path="*" element={<Navigate to="/gestion4sat/dashboard" replace />} />
                        </Routes>
                    </ProtectedRoute>
                }
            />
        </Routes>
    );
}

function App() {
    return (
        <ThemeProvider>
            <AuthProvider>
                <BrowserRouter>
                    <AppRoutes />
                    <Toaster 
                        position="top-right" 
                        richColors 
                        closeButton
                        toastOptions={{
                            className: 'font-sans',
                        }}
                    />
                </BrowserRouter>
            </AuthProvider>
        </ThemeProvider>
    );
}

export default App;
